<div class="switch-user-wrapper" *ngIf="isSwitchUser">
  <div class="header-top-note-section">
    <p>
      You are currently viewing <span>{{ switchUserData?.name }}</span>
    </p>

    <button mat-button class="btn-exit" style="height: 0px !important" (click)="exitSwitchUser()">
      <img src="./assets/images/exit-icon-white.svg" alt="Exit" /><span class="text-light">Exit</span>
    </button>
  </div>
</div>
<header class="header" [style.height]="isSwitchUser ? '95px' : '72px'">
  <!-- <a href="javascript:void(0)" class="logo" (click)="isOnMailPage ? redirectToDashboard() : null">
    <img [src]="brandLogo" alt="Crizac" title="Crizac" />
  </a> -->
  <!-- Search bar Start -->
  <div class="search-bar">
    <mat-form-field appearance="fill">
      <input matInput type="text" placeholder="Enter CAMS ID, Student Name, Passport No. here..." [(ngModel)]="search"
        [ngModelOptions]="{ standalone: true }" (keyup.enter)="searchApplicant()" />
    </mat-form-field>

    <button mat-icon-button aria-label="Search" type="button" (click)="searchApplicant()">
      <mat-icon>search</mat-icon>
    </button>
  </div>
  <!-- Search bar End -->

  <div class="header-rht">

    <!-- Theme Toggle -->
    <div class="theme-dropdown me-3">
      <button 
        class="btn-theme"
        mat-icon-button
        matTooltip="{{ isDarkMode ? 'Switch to Day mode' : 'Switch to Night mode' }}"
        (click)="toggleTheme()"
        aria-label="Toggle day/night theme"
      >
        <mat-icon [ngClass]="isDarkMode ? 'sun-icon' : 'moon-icon'">
          {{ isDarkMode ? 'light_mode' : 'dark_mode' }}
        </mat-icon>
      </button>
    </div>

    <!--Crizac MRC-->
    <button mat-button class="btn-emp-dir crizac-mrc" (click)="goToCrizacMRC()" *ngIf="idPemission">
      <span class="label">MRC</span>
    </button>
    <!--QR Code-->
    @if ([permissions_entity.modules.qr_code] | permissions | async) {
    <button mat-button class="btn-emp-dir" matTooltip="QR" [matMenuTriggerFor]="qrMenu" (menuOpened)="onMenuOpened()">
      <img src="./assets/images/qr-code-line.svg" alt="QR" />
    </button>
    }

    <mat-menu #qrMenu="matMenu" xPosition="before" class="notification-dropdown-wrapper">
      <app-custom-component #qrRef></app-custom-component>
    </mat-menu>

    <!-- Apps -->
    @if([
    permissions_entity.modules.mail_box,
    permissions_entity.modules.calendar_events,
    permissions_entity.modules.meeting_events,
    permissions_entity.modules.my_drive,
    permissions_entity.modules.internal_chat,
    permissions_entity.modules.tms_my_task,
    permissions_entity.modules.hitl,
    permissions_entity.modules.course_automation_portal
    ] | permissions | async){
    <div class="apps-dropdown">
      <button class="btn-apps" mat-button [matMenuTriggerFor]="appsMenu" matTooltip="Apps">
        <img src="./assets/images/apps-icon-gray.svg" alt="Apps" />
      </button>
      <mat-menu #appsMenu="matMenu" xPosition="before" class="apps-menu-dropdown-wrapper">
        <!-- Show Dashboard when on mail page, Mailbox otherwise -->
        <!-- @if ([permissions_entity.modules.dashboard] | permissions | async) {
        <button mat-menu-item *ngIf="isOnMailPage" (click)="redirectToDashboard()">
          <img src="./assets/images/dashboard-icon-gray.svg" alt="Dashboard" />
          Dashboard
        </button>
        } -->

        @if ([permissions_entity.modules.mail_box] | permissions | async) {
        <button mat-menu-item *ngIf="!isOnMailPage" (click)="redirectToMailPage()">
          <img src="./assets/images/mailbox-icon-gray.svg" alt="Mailbox" />
          Mailbox
        </button>
        }

        @if (
        [permissions_entity.modules.calendar_events] | permissions | async
        ) {
        <button mat-menu-item (click)="redirectToLeavesPage()" *ngIf="!isSwitchUser">
          <img src="./assets/images/leaves-icon-gray.svg" alt="Travel Event" />
          Travel Events
        </button>
        }

        @if (
        [permissions_entity.modules.meeting_events] | permissions | async
        ) {
        <button mat-menu-item (click)="redirectMeetingEvents()" *ngIf="!isSwitchUser">
          <img src="./assets/images/leaves-icon-gray.svg" alt="Meeting Event" />
          Meeting Events
        </button>
        }

        @if (
        [permissions_entity.modules.room_booking] | permissions | async
        ) {
        <button mat-menu-item (click)="redirectRoomBooking()" *ngIf="!isSwitchUser">
          <img src="./assets/images/conference-room-icon-gray.svg" alt="Book Conference Room" />
          Book Conference Room
        </button>
        }

        <!-- <button mat-menu-item>
          <img src="./assets/images/chat-master-icon-gray.svg" alt="Chat Master" />
          Chat v3
        </button> -->

        @if ([permissions_entity.modules.my_drive] | permissions | async) {
        <button mat-menu-item (click)="goToFileManagerV3()">
          <img class="icon normal" src="./assets/images/file-mager-gray.svg" alt="File Manager" />
          File Manager
        </button>
        }

        @if ([permissions_entity.modules.internal_chat] | permissions | async) {
        <button mat-menu-item (click)="internalChat()" *ngIf="!isSwitchUser">
          <img class="internal-chat-icon" src="./assets/images/chat-icon-gray.svg" alt="Chat" />
          Crizac Chat
        </button>
        }

        @if ([permissions_entity.modules.tms_my_task] | permissions | async) {
        <button mat-menu-item (click)="tms()" *ngIf="!isSwitchUser">
          <img class="internal-chat-icon" src="./assets/images/chat-icon-gray.svg" alt="Chat" />
          TMS
        </button>
        }
        @if ([permissions_entity.modules.hitl] | permissions | async) {
        <button mat-menu-item (click)="gotoHITL()">
          <img class="internal-chat-icon" src="./assets/images/loop-right-ai-line.svg" alt="Chat" />
          HITL
        </button>
        }

        @if (
        [permissions_entity.modules.course_automation_portal]
        | permissions
        | async
        ) {
        <button mat-menu-item (click)="redirectToAutomationPortal()" *ngIf="!isSwitchUser">
          <img src="./assets/images/automation-icon-gray.svg" alt="Course Automation" />
          Course Automation
        </button>
        }

        @if(isMoMoPermission){
        <button mat-menu-item (click)="momos()" *ngIf="!isSwitchUser">
          <img class="internal-chat-icon" src="./assets/images/meeting.svg" alt="Chat" />
          MoMOS
        </button>
        }

        @if ([permissions_entity.modules.tms_my_task] | permissions | async) {
        <button mat-menu-item (click)="newsletter()">
          <img class="internal-chat-icon" src="./assets/images/chat-icon-gray.svg" alt="Chat" />
          Newsletter
        </button>
        }

        @if (isEnrolyPermission) {
          <button mat-menu-item (click)="Enroly()">
            <img class="internal-chat-icon" src="./assets/images/External-icon-gray.svg" alt="External" />
            Enroly
          </button>
        }

      </mat-menu>
    </div>
    }

    <!-- Away -->
    <button mat-button class="btn-emp-dir btn-away" matTooltip="Away" (click)="markAsAway()"
      *ngIf="!isSwitchUser">
      <mat-icon>schedule</mat-icon>
    </button>

    <!-- Emp. Dir -->
    @if (
    [permissions_entity.modules.employee_directory] | permissions | async
    ) {
    <button mat-button
      class="btn-emp-dir position-relative d-inline-flex flex-column align-items-center justify-content-center"
      (click)="openEmployeeDirectory()">
      <img src="./assets/images/emp-icon-gray.svg" alt="Employee" title="Employee" />
      <span *ngIf="extNo" class="emp-count">
        {{ extNo }}
        <span class="visually-hidden">Extension Number</span>
      </span>
    </button>
    }

    <!-- Holiday List -->
    <!-- <button mat-button class="btn-holiday-list">
      <img src="./assets/images/holiday-icon-blue.svg" alt="Holiday" title="Holiday" />
      Holiday List
    </button> -->

    <!-- Schedule -->
    <!-- <button class="btn-date" mat-stroked-button>
      <img src="./assets/images/date-icon-blue.svg" alt="Date" title="Date" />
      8th June,2025
    </button> -->

    <!-- Commission -->
    @if (
    (permissions_entity.modules.agent_commission | permissions | async) ||
    (permissions_entity.modules.agent_commission_ucol | permissions | async)
    ) {
    <div class="commission-dropdown">
      <button class="btn-commission" mat-button [matMenuTriggerFor]="commissionMenu" matTooltip="Commission">
        <img class="lft" src="./assets/images/commission-icon-gray.svg" alt="Commission" />
      </button>
      <mat-menu #commissionMenu="matMenu" xPosition="before" class="commission-menu-dropdown-wrapper">
        @if ([permissions_entity.modules.agent_commission] | permissions | async) {
        <button mat-menu-item (click)="gotoCrizac()">
          Agent Commission Crizac
        </button>
        }
        @if ([permissions_entity.modules.agent_commission_ucol] | permissions | async) {
        <button mat-menu-item (click)="gotoUcol()">
          Agent Commission Ucol
        </button>
        }
        @if (false) {
        <button mat-menu-item (click)="gotoGaspl()">
          Agent Commission Gaspl
        </button>
        }
      </mat-menu>
    </div>
    }

    <!-- Notification -->
    @if (([permissions_entity.modules.admin_notice_board] | permissions | async) ||
    ([permissions_entity.modules.agent_notice_board] | permissions | async) ||
    ([permissions_entity.modules.agent_webinar_board] | permissions | async)) {
    <div class="commission-dropdown">
      <button class="btn-commission" mat-button [matMenuTriggerFor]="commissionMenu" matTooltip="Special Features">
        <img src="./assets/images/feature-icon-gray.svg" alt="Notification" />
      </button>
      <mat-menu #commissionMenu="matMenu" xPosition="before" class="commission-menu-dropdown-wrapper">
        @if ([permissions_entity.modules.admin_notice_board] | permissions | async) {
        <button mat-menu-item (click)="gotoAdminNotice()">
          <img class="icon normal" src="./assets/images/admin-notice-board-icon-gray.svg" alt="Admin Notice Board" />
          Admin Notice Board
        </button>
        }

        @if ([permissions_entity.modules.agent_notice_board] | permissions | async) {
        <button mat-menu-item (click)="gotoFrontendNotice()">
          <img class="icon normal" src="./assets/images/admin-notice-board-icon-gray.svg" alt="Frontend Notice Board" />
          Agent Notice Board
        </button>
        }

        @if ([permissions_entity.modules.agent_webinar_board] | permissions | async) {
        <button mat-menu-item (click)="gotoFrontendWebinar()">
          <img class="icon normal" src="./assets/images/admin-notice-board-icon-gray.svg"
            alt="Frontend Webinar Board" />
          Agent Webinar Board
        </button>
        }
      </mat-menu>
    </div>
    }

    <!-- Notification -->
    <!-- <div class="notification-dropdown">
      <button class="btn-notification-dropdown" mat-button [matMenuTriggerFor]="notificationMenu"
        matTooltip="Notification">
        <img src="./assets/images/notification-icon-gray.svg" alt="Notification" />
        <span class="notification-alert"></span>
      </button>
      <mat-menu #notificationMenu="matMenu" xPosition="before" class="notification-dropdown-wrapper">
        <div class="notification-dropdown-header">
          <h2>Notification</h2>
          <button mat-button>Mark all as read</button>
        </div>
        <div class="notification-dropdown-body">
          <ul>
            <li class="read">
              <a href="javascript:void()">Lorem Ipsum is simply dummy text of the printing and
                typesetting industry</a>
            </li>
            <li>
              <a href="javascript:void()">Lorem Ipsum is simply dummy text of the printing and
                typesetting industry</a>
            </li>
          </ul>
        </div>
        <div class="notification-dropdown-footer">
          <button mat-button>View All</button>
        </div>
        <app-notifications></app-notifications>
      </mat-menu>
    </div> -->

    <!-- User Dropdown -->
    <div class="user-menu-dropdown">
      <button mat-button [matMenuTriggerFor]="beforeMenu" [matTooltip]="tooltipText" [matTooltipPosition]="'above'"
        class="border-0 bg-transparent p-0">
        <img [src]="selectedImageSrc" alt="User profile picture" class="rounded-circle transition" style="
            transition:
              transform 0.3s ease,
              opacity 0.3s ease;
          " onmouseover="this.style.transform = 'scale(1.1)'" onmouseout="this.style.transform = 'scale(1)'"
          onfocus="this.style.transform = 'scale(1.1)'" onblur="this.style.transform = 'scale(1)'" height="40"
          width="40" />
      </button>

      <mat-menu #beforeMenu="matMenu" xPosition="before" class="user-menu-dropdown-wrapper">
        <button mat-menu-item class="notification-menu-item" (click)="$event.stopPropagation()">
          <div class="menu-content">
            <div class="menu-left">
              <mat-icon>notifications</mat-icon>
              <span>Notification</span>
            </div>

            <mat-slide-toggle
              [(ngModel)]="notificationEnabled"
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="toggleNotification($event)">
            </mat-slide-toggle>
          </div>
        </button>
        <button mat-menu-item (click)="openProfileDialog()" *ngIf="!isSwitchUser">
          <mat-icon style="color: #687279; margin-right: 8px;">account_circle</mat-icon>
          <span style="font-weight: 500;">Profile</span>
        </button>
        @if (!isSwitchUser) {
        <button mat-menu-item (click)="delegateUserAccessDialog()" *ngIf="DelisSwitchUser">
          <mat-icon style="color: #687279; margin-right: 8px;">manage_accounts</mat-icon>
          <span style="font-weight: 500;">Delegate User Access</span>
        </button>
        }
        <button mat-menu-item (click)="openDialog()" *ngIf="!isSwitchUser">
          <mat-icon style="color: #687279; margin-right: 8px;">lock_reset</mat-icon>
          <span style="font-weight: 500;">Reset Password</span>
        </button>
        @if ([permissions_entity.modules.holiday_master] | permissions | async) {
        <button mat-menu-item (click)="openHolidayMaster()" *ngIf="!isSwitchUser">
          <mat-icon style="color: #687279; margin-right: 8px;">beach_access</mat-icon>
          <span style="font-weight: 500;">Holiday Master</span>
        </button>
        }
        <button mat-menu-item (click)="logout()" class="logout-btn">
          <mat-icon style="color: #f26522; margin-right: 8px;">power_settings_new</mat-icon>
          <span style="font-weight: 500;">Logout</span>
        </button>
      </mat-menu>
    </div>
  </div>
</header>